import React from "react";
import PageHeader from "../PageHeader/PageHeader";
import { defineMessages, FormattedMessage } from "react-intl";
import longMessage from "../../../../../../../macros/longMessage.macro";
import track from "react-tracking";
const messages = defineMessages({
    header: {
        id: "accessibility.header",
        defaultMessage: "Accessibility"
    }
});
const Accessibility = () => (<div className="wrapper">
		<PageHeader header={messages.header}/>

		<div className="text">
			<FormattedMessage tagName="p" id="accessibility.message" defaultMessage={longMessage `
					DCMS strives to adhere to web accessibility guidelines. If you encounter any difficulty in
					using our website, please contact us at {link} or {phone}.
					We appreciate your feedback on accessibility so that we can continue to improve.
				`} values={{
    link: (<a className="link" href="mailto:accessibility@dcmservices.com">
							accessibility@dcmservices.com
						</a>),
    phone: (<a className="link" href="tel:+18448919246" itemProp="telephone">
							1-844-891-9246
						</a>)
}}/>
		</div>
	</div>);
export default track({ page: "Accessibility" }, { dispatchOnMount: true })(Accessibility);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/legal/Accessibility/Accessibility.tsx